import { HeadConfig } from "types/types";
import { Helmet } from "react-helmet";
import { logDebug } from "helpers/generic";
import React from "react";

interface Props {
  headConfig: HeadConfig;
}

const Head = ({ headConfig }: Props) => {
  const { pageHrefLang, lang, robots, seo, location, jsonLd } = headConfig;
  logDebug("HELMET", headConfig);

  return (
    <Helmet
      link={Object.entries(pageHrefLang).map(([key, value]) => ({
        rel: "alternate",
        href: `/${key}/${value}`,
        hrefLang: key,
        key,
      }))}
    >
      <html lang={lang} />
      <title>{seo.pageTitle}</title>

      <meta name="description" content={seo.pageDescription || ""} />

      <meta property="og:url" content={location.href} />
      <meta property="og:title" content={seo.ogPageTitle || ""} />
      <meta property="og:description" content={seo.ogPageDescription || ""} />
      <meta property="og:image" content={`https:${seo.ogPageImage.file.url}`} />
      <meta property="og:type" content={seo.ogPageType || ""} />
      <meta name="robots" content={robots} />
      {/* NOTE: canonicals are automatic */}
      {/* <base href={process.env.GATSBY_SITE_URL} /> */}
      {typeof window !== "undefined" && <base href={window.location.origin} />}

      {jsonLd && <script type="application/ld+json">{jsonLd}</script>}
    </Helmet>
  );
};

export default Head;
